import { render } from "./BranchCategoryMultiselect.vue?vue&type=template&id=12d9e1fc"
import script from "./BranchCategoryMultiselect.vue?vue&type=script&lang=js"
export * from "./BranchCategoryMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__